import React, { ReactElement } from "react";
import WaveBottom from "../../assets/img/wave-bottom.svg";
import WaveHome from "../../assets/img/wave-home.svg";
import "./Wave.scss";

const WAVES = {
    bottom: WaveBottom,
    home: WaveHome,
};

export interface Props {
    wave?: "bottom" | "home";
    type?: "sm" | "lg";
    className?: string;
    children: ReactElement | ReactElement[];
}

export default function Wave(props: Props): ReactElement {
    return (
        <div className={`${props.className} bg-wave bg-wave-${props.type} bg-gradient`}>
            <div className="in-wave">
                {props.children}
            </div>
            <img src={WAVES[props.wave ?? "bottom"]} alt="Wave styling" className="wave-img" />
        </div>
    );
}
Wave.defaultProps = {
    className: "",
    wave: "bottom",
    type: "",
};
